import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.5 20.677a1 1 0 001 1h16a1 1 0 100-2h-1v-12a2 2 0 00-2-2h-2a2 2 0 00-2-2h-6a2 2 0 00-2 2v14h-1a1 1 0 00-1 1zm4-15v14h6v-14h-6zm10 14h-2v-12h2v12zm-7-8v2h2v-2h-2z" fill="#444" /></svg>;